import React from "react";

// constants
const noStudentBoxProps = {
    defaultText: "Please enter students Unique Id to view more details.",
};

// material
import { Box, Typography, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    defaultText: {
        width: "100%",
        padding: theme.spacing(1),
        margin: theme.spacing(10, 0),
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(3),
        alignItems: "center",
        textAlign: "center",
    },
    studentDetailsItem: {
        padding: theme.spacing(2),
        [theme.breakpoints.down("md")]: {
            padding: theme.spacing(1),
        },
    },
    button: {
        color: theme.palette.common.white,
    },
}));

export default function NoStudentBox() {
    const { defaultText } = noStudentBoxProps;
    const classes = useStyles();

    return (
        <Box className={classes.defaultText}>
            <Typography color="primary" variant="h1">
                {defaultText}
            </Typography>
        </Box>
    );
}
